import { environment } from '../../../environments/environment';

declare global {
    interface Window {
        __runtimeConfig?: {
            apiUrl?: string;
        };
    }
}

export const runtimeConfig = {
    apiUrl: window.__runtimeConfig?.apiUrl?.trim() || environment.apiUrl,
};